import { render } from "./BimFileAccess.vue?vue&type=template&id=165ac200&scoped=true"
import script from "./BimFileAccess.vue?vue&type=script&lang=js"
export * from "./BimFileAccess.vue?vue&type=script&lang=js"

import "./BimFileAccess.vue?vue&type=style&index=0&id=165ac200&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165ac200"]])

export default __exports__